module.exports = __webpack_public_path__ + "img/endsession.8a3adb13.svg";